var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: "详情",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, "label-width": "120px" }
        },
        _vm._l(_vm.form.params, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "flex-wrap": "wrap"
              }
            },
            [
              _c("div", { staticClass: "langTitle" }, [
                _vm._v(" " + _vm._s(item.languageName) + " ")
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "地区", prop: "params." + index + ".area" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入地区" },
                    model: {
                      value: item.area,
                      callback: function($$v) {
                        _vm.$set(item, "area", $$v)
                      },
                      expression: "item.area"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "地区产品名称",
                    prop: "params." + index + ".game_area_name"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入地区产品名称" },
                    model: {
                      value: item.game_area_name,
                      callback: function($$v) {
                        _vm.$set(item, "game_area_name", $$v)
                      },
                      expression: "item.game_area_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "地区产品描述",
                    prop: "params." + index + ".game_area_desc"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入地区产品描述" },
                    model: {
                      value: item.game_area_desc,
                      callback: function($$v) {
                        _vm.$set(item, "game_area_desc", $$v)
                      },
                      expression: "item.game_area_desc"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "服务器名称",
                    prop: "params." + index + ".server_name"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入标题" },
                    model: {
                      value: item.server_name,
                      callback: function($$v) {
                        _vm.$set(item, "server_name", $$v)
                      },
                      expression: "item.server_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "页面标题",
                    prop: "params." + index + ".page_title"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "页面标题" },
                    model: {
                      value: item.page_title,
                      callback: function($$v) {
                        _vm.$set(item, "page_title", $$v)
                      },
                      expression: "item.page_title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    label: "背景图",
                    prop: "params." + index + ".banner"
                  }
                },
                [
                  _c("uploadImageOne", {
                    attrs: { disabled: "", value: item.picfileList },
                    on: {
                      input: function($event) {
                        return _vm.imgChange($event, item, index, "")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    label: "背景图",
                    prop: "params." + index + ".bannerMb"
                  }
                },
                [
                  _c("uploadImageTow", {
                    attrs: { disabled: "", value: item.picfileListMb },
                    on: {
                      input: function($event) {
                        return _vm.imgChange($event, item, index, "Mb")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    label: "充值描述",
                    prop: "params." + index + ".recharge_desc"
                  }
                },
                [
                  _c("Editor", {
                    model: {
                      value: item.recharge_desc,
                      callback: function($$v) {
                        _vm.$set(item, "recharge_desc", $$v)
                      },
                      expression: "item.recharge_desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }